<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="800">
      <template v-slot:activator="{ on, attrs }">
        <v-btn text v-bind="attrs" v-on="on">
          <div v-if="videoButton">
            <v-icon x-large>mdi-play-circle</v-icon>
          </div>
          <div v-else>
            {{ applicant.user.firstName }} {{ applicant.user.surname }}
          </div>
        </v-btn>
      </template>

      <v-card>
        <v-card-title class="headline grey lighten-2"
          >{{ applicant.user.firstName }}
          {{ applicant.user.surname }}</v-card-title
        >

        <Video :videoId="applicant.video" styled="true" muted="false" />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Video from '@/components/Video';

export default {
  data() {
    return {
      dialog: false,
    };
  },
  components: { Video },
  props: ['applicant', 'videoButton'],
  methods: {
    pause() {
      this.$refs.player.pause();
    },
  },
};
</script>

<style></style>
